export default "__VITE_ASSET__f804b65e__"